/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/creditcard/CreditCardScannerUserGuidance.yaml
import { BackgroundStyle, StyledText } from '../common/Common';
/**
Configure the captions of the user guidance hints for different scanning states.
*/
export class CreditCardScannerGuidanceStates {
    /** @param source {@displayType `DeepPartial<CreditCardScannerGuidanceStates>`} */
    constructor(source = {}) {
        /**
          The user guidance text displayed when no credit card is found. Initial state.
          
          Default is "?creditCardUserGuidanceNoCardFound"
          */
        this.noCardFound = '?creditCardUserGuidanceNoCardFound';
        /**
          The user guidance text displayed when a card presence was detected and scanning is in progress.
          
          Default is "?creditCardUserGuidanceScanningProgress"
          */
        this.scanningProgress = '?creditCardUserGuidanceScanningProgress';
        /**
          The user guidance text displayed when it is too dark to capture an adequate image.
          
          Default is "?creditCardUserGuidanceTooDark"
          */
        this.tooDark = '?creditCardUserGuidanceTooDark';
        /**
          The user guidance text displayed when the detected card is too far away and appears too small.
          
          Default is "?creditCardUserGuidanceTooSmall"
          */
        this.tooSmall = '?creditCardUserGuidanceTooSmall';
        /**
          The user guidance text displayed when the detected card is not in a good perspective (device tilted).
          
          Default is "?creditCardUserGuidanceBadPerspective"
          */
        this.badPerspective = '?creditCardUserGuidanceBadPerspective';
        if (source.noCardFound !== undefined) {
            this.noCardFound = source.noCardFound;
        }
        if (source.scanningProgress !== undefined) {
            this.scanningProgress = source.scanningProgress;
        }
        if (source.tooDark !== undefined) {
            this.tooDark = source.tooDark;
        }
        if (source.tooSmall !== undefined) {
            this.tooSmall = source.tooSmall;
        }
        if (source.badPerspective !== undefined) {
            this.badPerspective = source.badPerspective;
        }
    }
}
/**
Configuration of the hints guiding users through the credit card scanning process.
*/
export class CreditCardScanGuidanceConfiguration {
    /** @param source {@displayType `DeepPartial<CreditCardScanGuidanceConfiguration>`} */
    constructor(source = {}) {
        /**
          Determines whether the user guidance hints should be visible (enabled).
          
          Default is true
          */
        this.visibility = true;
        /**
          Configure the text style for the user guidance hints.
          */
        this.title = new StyledText({ text: '?creditCardUserGuidanceNoCardFound', color: '?sbColorOnPrimary' });
        /**
          Configure the background style for the user guidance hints.
          */
        this.background = new BackgroundStyle({
            strokeColor: '#00000000',
            fillColor: '?sbColorSurfaceLow',
        });
        /**
          Configure the captions of the user guidance hints for different states.
          */
        this.statesTitles = new CreditCardScannerGuidanceStates({});
        if (source.visibility !== undefined) {
            this.visibility = source.visibility;
        }
        if (source.title !== undefined) {
            this.title = new StyledText(source.title);
        }
        if (source.background !== undefined) {
            this.background = new BackgroundStyle(source.background);
        }
        if (source.statesTitles !== undefined) {
            this.statesTitles = new CreditCardScannerGuidanceStates(source.statesTitles);
        }
    }
}
//# sourceMappingURL=CreditCardScannerUserGuidance.js.map